import api from './api';
/**
 * 首页产品推荐
 * @param {proType} integer
 * 0 实物产品
 * 1 平台产品
 */
export function productList(params) {
  return api.post('/product/getProList', {
    proType: params
  }, true, false);
}

/**
 * 获得具体单个设备信息
 * @param {proId} integer
 * 产品ID
 */
export function oneProductInfo(params) {
  return api.post('/product/getProduct', {
    proId: params
  }, true, false);
}

/**
 * 获得所有产品列表
 * @param {proType} integer
 * 0 实物产品
 * 1 平台产品
 */
export function allProductList(params) {
  return api.post('/product/getAllProList', {
    proType: params
  }, true, false);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/product.js